import { APP_PREFIX } from "../config/appIdentifiers";

const STORAGE_KEY = `${APP_PREFIX}:food-note-memory:v1`;
const MAX_ITEMS = 250;

const normalizeText = (value = "") => String(value)
  .trim()
  .toLowerCase()
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .replace(/\s+/g, " ")
  .trim();

const buildFoodKey = ({ barcode = "", name = "", brand = "" } = {}) => {
  const code = normalizeText(barcode);
  if (code) return `code:${code}`;
  const n = normalizeText(name);
  const b = normalizeText(brand);
  if (!n) return "";
  return `name:${n}|brand:${b}`;
};

const readStore = () => {
  if (typeof window === "undefined") return { byKey: {}, order: [] };
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { byKey: {}, order: [] };
    const parsed = JSON.parse(raw);
    const byKey = parsed?.byKey && typeof parsed.byKey === "object" ? parsed.byKey : {};
    const order = Array.isArray(parsed?.order) ? parsed.order : [];
    return { byKey, order };
  } catch {
    return { byKey: {}, order: [] };
  }
};

const writeStore = (store) => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    // ignore storage write errors
  }
};

export const getRememberedFoodNote = ({ barcode, name, brand } = {}) => {
  const key = buildFoodKey({ barcode, name, brand });
  if (!key) return "";
  const store = readStore();
  const entry = store.byKey?.[key];
  if (!entry || typeof entry.note !== "string") return "";
  return entry.note;
};

export const rememberFoodNote = ({ barcode, name, brand, note } = {}) => {
  const safeNote = typeof note === "string" ? note.trim() : "";
  if (!safeNote) return false;

  const key = buildFoodKey({ barcode, name, brand });
  if (!key) return false;

  const store = readStore();
  const nextByKey = { ...(store.byKey || {}) };
  const now = new Date().toISOString();

  nextByKey[key] = {
    note: safeNote,
    updatedAt: now,
  };

  const prevOrder = Array.isArray(store.order) ? store.order : [];
  const nextOrder = [key, ...prevOrder.filter((k) => k !== key)].slice(0, MAX_ITEMS);

  // drop overflow
  const trimmedByKey = {};
  nextOrder.forEach((k) => {
    if (nextByKey[k]) trimmedByKey[k] = nextByKey[k];
  });

  writeStore({ byKey: trimmedByKey, order: nextOrder });
  return true;
};

